import React from 'react';

function BankGuarantees() {
  const banks = [
    { name: 'Сбербанк', rate: '2.5%', amount: 'до 500 млн ₽', term: 'до 36 месяцев', url: 'https://www.sberbank.ru/ru/legal/bankguarantee' },
    { name: 'ВТБ', rate: '2.8%', amount: 'до 300 млн ₽', term: 'до 24 месяцев', url: 'https://www.vtb.ru/business/bankovskie-garantii/' },
    { name: 'ПСБ', rate: '3.0%', amount: 'до 200 млн ₽', term: 'до 24 месяцев', url: 'https://www.psbank.ru/Business/BankGuarantees' },
    { name: 'Альфа-Банк', rate: '2.7%', amount: 'до 150 млн ₽', term: 'до 12 месяцев', url: 'https://alfabank.ru/sme/bankguarantees/' },
    { name: 'Банк ДОМ.РФ', rate: '2.9%', amount: 'до 100 млн ₽', term: 'до 24 месяцев', url: 'https://банк.дом.рф/business/bankguarantees/' },
  ];

  return (
    <div>
      <h2>Bank Guarantees</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Independent bank guarantees for government contracts (44-FZ, 223-FZ, 615-PP)
      </p>

      <div style={{ marginBottom: 20, padding: 14, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
        <h3 style={{ marginBottom: 8 }}>How to get a guarantee</h3>
        <ol style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          <li style={{ marginBottom: 4 }}>Choose a bank from the list below</li>
          <li style={{ marginBottom: 4 }}>Prepare documents: INN, financial statements, contract draft</li>
          <li style={{ marginBottom: 4 }}>Submit application through the bank's website</li>
          <li style={{ marginBottom: 4 }}>Get approval in 1–5 business days</li>
          <li>Receive the guarantee and submit to the trading platform</li>
        </ol>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
            <th style={{ padding: 8 }}>Bank</th>
            <th style={{ padding: 8 }}>Rate</th>
            <th style={{ padding: 8 }}>Amount</th>
            <th style={{ padding: 8 }}>Term</th>
            <th style={{ padding: 8 }}>Link</th>
          </tr>
        </thead>
        <tbody>
          {banks.map((b, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
              <td style={{ padding: 8 }}>{b.name}</td>
              <td style={{ padding: 8 }}>{b.rate}</td>
              <td style={{ padding: 8 }}>{b.amount}</td>
              <td style={{ padding: 8 }}>{b.term}</td>
              <td style={{ padding: 8 }}>
                <a href={b.url} target="_blank" rel="noopener noreferrer" style={{ color: '#6366F1', textDecoration: 'none' }}>
                  Apply →
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BankGuarantees;